import { Typography } from '@mui/material';
import Button from '../foundation/Button/Button';
import DialogWithHeader from '../foundation/DialogWithHeader';
import {
    GoogleAuthNoticeActions,
    GoogleAuthNoticeContent,
    GoogleAuthNoticeIllustration,
} from './GoogleAuthNoticeDialog.styles';

export type GoogleRegistrationRequiredDialogProps = {
    open: boolean
    onClose: () => void
    onRegister: () => void
};

export default function GoogleRegistrationRequiredDialog(
    props: GoogleRegistrationRequiredDialogProps,
) {
    return <DialogWithHeader
        open={props.open}
        onClose={props.onClose}
        title="נדרשת הרשמה"
    >
        <GoogleAuthNoticeContent>
            <GoogleAuthNoticeIllustration
                src="/images/registration-required.png"
                alt="איור כרטיס משתמש"
            />
            <Typography variant="h5" fontWeight="bold">רגע לפני שממשיכים</Typography>
            <Typography variant="body1" color="text.secondary">
                כדי להמשיך בתהליך, צריך ליצור חשבון חדש ולאשר את התקנון.
            </Typography>
            <GoogleAuthNoticeActions>
                <Button fullWidth size="large" onClick={props.onRegister}>להרשמה</Button>
            </GoogleAuthNoticeActions>
        </GoogleAuthNoticeContent>
    </DialogWithHeader>;
}
